/* eslint-disable import/prefer-default-export */
export const fisio = [
    {
        normalPositivo: `Paciente submetido a ecocardiografia com ESTRESSE FISIOLÓGICO EM ESTEIRA para investigação de Isquemia Miocárdica.
ECG-BASAL: segmento ST dentro dos limites da normalidade.
TE-ESTRESSE: paciente andou por --- minutos no protocolo Bruce, com VO2 máximo = --- ml/Kg/min e Duplo produto = ---. Atingiu FC = --- bpm (FCmáx = --- e FCsubmáx = ---), PArepouso = --- mmHg e PAmáxima = --- mmHg.
PREDITORES DE MORTALIDADE E EVENTOS CARDIOVASCULARES:
* Recuperação da FC no 1º minuto após o exercício = --- bpm (anormal se a queda for menor ou igual a 18 btms/min).
* Capacidade Funcional = --- METS. Anormal quando menor que --- METS ( 85% da prevista de acordo com a idade e sexo).
* Resposta Cronotrópica = ---% (anormal quando menor que 80%, quando em uso de B-bloq. menor que 62%).
* Duke escore = --- (risco ---).
Comportamento normal da pressão arterial.
Análise eletrocardiográfica apresentando resposta normal ao esforço realizado.
Ausência de arritmias. Paciente apresentou cansaço físico.

ECO-REPOUSO:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade miocárdica normal em repouso.
- Strain Longitudinal Global do VE: ---% (valor de referência é menor que -18%)
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.
2 - Capacidade funcional ---.`,
    },
    {
        normalNegativo: `Paciente submetido a ecocardiografia com ESTRESSE FISIOLÓGICO EM ESTEIRA para investigação de Isquemia Miocárdica.
ECG-BASAL: segmento ST dentro dos limites da normalidade.
TE-ESTRESSE: paciente andou por --- minutos no protocolo Bruce, com VO2 máximo = --- ml/Kg/min e Duplo produto = ---. Atingiu FC = --- bpm (FCmáx = --- e FCsubmáx = ---), PArepouso = --- mmHg e PAmáxima = --- mmHg.
PREDITORES DE MORTALIDADE E EVENTOS CARDIOVASCULARES:
* Recuperação da FC no 1º minuto após o exercício = --- bpm (anormal se a queda for menor ou igual a 18 btms/min).
* Capacidade Funcional = --- METS. Anormal quando menor que --- METS ( 85% da prevista de acordo com a idade e sexo).
* Resposta Cronotrópica = ---% (anormal quando menor que 80%, quando em uso de B-bloq. menor que 62%).
* Duke escore = --- (risco ---).
Comportamento normal da pressão arterial.
Análise eletrocardiográfica apresentando resposta normal ao esforço realizado.
Ausência de arritmias. Paciente apresentou cansaço físico.

ECO-REPOUSO:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade miocárdica normal em repouso.
- Strain Longitudinal Global do VE: ---% (valor de referência é menor que -18%)
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.
2 - Capacidade funcional ---.`,
    },
    {
        alteradoPositivo: `Paciente submetido a ecocardiografia com ESTRESSE FISIOLÓGICO EM ESTEIRA para investigação de Isquemia Miocárdica.
ECG-BASAL: segmento ST dentro dos limites da normalidade.
TE-ESTRESSE: paciente andou por --- minutos no protocolo Bruce, com VO2 máximo = --- ml/Kg/min e Duplo produto = ---. Atingiu FC = --- bpm (FCmáx = --- e FCsubmáx = ---), PArepouso = --- mmHg e PAmáxima = --- mmHg.
PREDITORES DE MORTALIDADE E EVENTOS CARDIOVASCULARES:
* Recuperação da FC no 1º minuto após o exercício = --- bpm (anormal se a queda for menor ou igual a 18 btms/min).
* Capacidade Funcional = --- METS. Anormal quando menor que --- METS ( 85% da prevista de acordo com a idade e sexo).
* Resposta Cronotrópica = ---% (anormal quando menor que 80%, quando em uso de B-bloq. menor que 62%).
* Duke escore = --- (risco ---).
Comportamento normal da pressão arterial.
Análise eletrocardiográfica apresentando resposta normal ao esforço realizado.
Ausência de arritmias. Paciente apresentou cansaço físico.

ECO-REPOUSO:
- Ventrículo esquerdo com função sistólica preservada.
- Disfunção diastólica do ventrículo esquerdo grau I.
- Hipertrofia ventricular esquerda tipo concêntrica de grau discreto.
- Raiz de Aorta (...) e Aorta Ascendente (...) com aumento discreto.
- Valva mitral exibe refluxo de grau discreto.
- Valva tricúspide exibe refluxo de grau discreto.
- Valva aórtica com folhetos espessados, abertura e mobilidades preservadas. Ao Doppler ausência de gradiente transvalvar significativo
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

OBSERVAÇÃO:
Paciente submetido a exame de ecocardiografia com estresse fisiológico em uso de medicação para controle de freqüência cardíaca (...), fato que pode interferir na acurácia do exame em predizer Isquemia Miocárdica.
CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.
2 - Capacidade funcional ---.`,
    },
    {
        alteradoNegativo: `Paciente submetido a ecocardiografia com ESTRESSE FISIOLÓGICO EM ESTEIRA para investigação de Isquemia Miocárdica.
ECG-BASAL: segmento ST dentro dos limites da normalidade.
TE-ESTRESSE: paciente andou por --- minutos no protocolo Bruce, com VO2 máximo = --- ml/Kg/min e Duplo produto = ---. Atingiu FC = --- bpm (FCmáx = --- e FCsubmáx = ---), PArepouso = --- mmHg e PAmáxima = --- mmHg.
PREDITORES DE MORTALIDADE E EVENTOS CARDIOVASCULARES:
* Recuperação da FC no 1º minuto após o exercício = --- bpm (anormal se a queda for menor ou igual a 18 btms/min).
* Capacidade Funcional = --- METS. Anormal quando menor que --- METS ( 85% da prevista de acordo com a idade e sexo).
* Resposta Cronotrópica = ---% (anormal quando menor que 80%, quando em uso de B-bloq. menor que 62%).
* Duke escore = --- (risco ---).
Comportamento normal da pressão arterial.
Análise eletrocardiográfica apresentando resposta normal ao esforço realizado.
Ausência de arritmias. Paciente apresentou cansaço físico.

ECO-REPOUSO:
- Ventrículo esquerdo com função sistólica preservada.
- Disfunção diastólica do ventrículo esquerdo grau I.
- Hipertrofia ventricular esquerda tipo concêntrica de grau discreto.
- Raiz de Aorta (...) e Aorta Ascendente (...) com aumento discreto.
- Valva mitral exibe refluxo de grau discreto.
- Valva tricúspide exibe refluxo de grau discreto.
- Valva aórtica com folhetos espessados, abertura e mobilidades preservadas. Ao Doppler ausência de gradiente transvalvar significativo
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

OBSERVAÇÃO:
Paciente submetido a exame de ecocardiografia com estresse fisiológico em uso de medicação para controle de freqüência cardíaca (...), fato que pode interferir na acurácia do exame em predizer Isquemia Miocárdica.
CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.
2 - Capacidade funcional ---.
`,
    },
];